module.exports = __webpack_public_path__ + "img/06.eaf9466c.jpg";